import { render, staticRenderFns } from "./VersionAuthCountDownModal.vue?vue&type=template&id=38df282c&scoped=true"
import script from "./VersionAuthCountDownModal.vue?vue&type=script&lang=ts"
export * from "./VersionAuthCountDownModal.vue?vue&type=script&lang=ts"
import style0 from "./VersionAuthCountDownModal.vue?vue&type=style&index=0&id=38df282c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df282c",
  null
  
)

export default component.exports